import React from "react";
import { object } from "prop-types";

import DfpContainer from "../../../ads/dfp-container";
import { DfpComponent } from "../../../ads/dfp-component";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import NewsWithImage from "../../../molecules/NewsWithImage";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";
import NewsHeadline from "../../../atoms/NewsHeadline";
import WidgetPlaceholder from "../WidgetPlaceholder";
import SpecialEvent from "../SpecialEvent";

import { getSlotId, getStoriesFromCollection, trim } from "../../../utils/utils";
import { useDeviceType } from "../../../utils/react-utils";

import "./tab-layout.m.css";

const TabLayout = ({ collection }) => {
  let {
    "associated-metadata": {
      widget_80_url: widget80,
      widget_100_url: widget100,
      widget_250_url: widget250,
      ad_slot_1: adSlot1,
      ad_slot_2: adSlot2,
    } = {},
  } = collection;
  widget80 = trim(widget80);
  widget100 = trim(widget100);
  widget250 = trim(widget250);

  const { tab } = useDeviceType();

  const items = getStoriesFromCollection(collection, 20);
  const [firstRow] = items;
  const secondRow = items.slice(1, 4);
  const thirdRow = items.slice(4, 6);
  const fourthRow = items.slice(6, 9);
  const fifthRow = items.slice(9, 12);
  const sixthRow = items.slice(12, 15);
  const seventhRow = items.slice(15);

  const bottomWidget = (() => {
    if (widget100) {
      return { height: 100, url: widget100, size: "small" };
    } else if (widget250) {
      return { height: 250, url: widget250, size: "big" };
    } else return null;
  })();

  return (
    <div styleName="base">
      <div styleName="first-row">
        <LeftImageRightNews story={firstRow} showCaption={true} showExcerpt={true} widths={[400]} />
        <DfpContainer styleName="r1-ad">
          {tab && (
            <DfpComponent
              type={adSlot1}
              collectionSlug={collection.slug}
              slotId={getSlotId(adSlot1, collection.slug, 10)}
              layoutName="FourteenStories3Ad1Widget"
            />
          )}
        </DfpContainer>
      </div>
      <SpecialEvent collection={collection} styleName="special-row" />
      <div styleName="second-row">
        {secondRow.map((story, index) => (
          <LeftImageRightNews
            aspectRatio={[1, 1]}
            imageType="image1x1"
            styleName="second-item"
            story={story}
            key={index}
            widths={[190]}
          />
        ))}
      </div>
      <div styleName="third-row">
        {widget80 ? (
          <div styleName="third-with-widget">
            <div styleName="left-side">
              {thirdRow.map((story, index) => (
                <NewsHeadline styleName="third-left-item" story={story} key={index} />
              ))}
            </div>
            <WidgetPlaceholder styleName="widget-80" height={80} url={widget80} />
          </div>
        ) : (
          <div styleName="third-without-widget">
            {thirdRow.map((story, index) => (
              <LeftImageRightNews
                aspectRatio={[1, 1]}
                imageType="image1x1"
                styleName="third-item"
                story={story}
                key={index}
                showExcerpt={true}
                widths={[220]}
              />
            ))}
          </div>
        )}
      </div>
      <div styleName="fourth-row">
        {fourthRow.map((story, index) => (
          <LeftImageRightNews
            aspectRatio={[1, 1]}
            imageType="image1x1"
            styleName="fourth-item"
            story={story}
            key={index}
            widths={[180]}
          />
        ))}
      </div>
      <div styleName="fifth-row">
        {fifthRow.map((story, index) => (
          <NewsWithImage styleName="fifth-item" story={story} key={index} widths={[360]} />
        ))}
      </div>

      <div styleName="sixth-row">
        {bottomWidget ? (
          <div styleName="sixth-with-widget">
            <div styleName="left-side">
              {sixthRow.map((story, index) => (
                <NewsWithNoImage
                  showExcerpt={bottomWidget?.size === "big"}
                  styleName="sixth-left-item"
                  story={story}
                  key={index}
                />
              ))}
            </div>
            <WidgetPlaceholder styleName={bottomWidget?.size} height={bottomWidget?.height} url={bottomWidget?.url} />
          </div>
        ) : (
          <div styleName="sixth-without-widget">
            {sixthRow.map((story, index) => (
              <NewsWithNoImage styleName="sixth-item" story={story} key={index} />
            ))}
          </div>
        )}
      </div>
      <div styleName="seventh-row">
        <div styleName="left-side">
          {seventhRow.map((story, index) => (
            <NewsHeadline styleName="seventh-item" story={story} key={index} />
          ))}
        </div>
        <DfpContainer styleName="b1-ad">
          {tab && (
            <DfpComponent
              type={adSlot2}
              collectionSlug={collection.slug}
              slotId={getSlotId(adSlot2, collection.slug, 2)}
              layoutName="FourteenStories3Ad1Widget"
            />
          )}
        </DfpContainer>
      </div>
    </div>
  );
};

TabLayout.propTypes = {
  collection: object,
};

export default TabLayout;
